import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import moment from 'moment';
import './MyBookings.css'; // A new CSS file for styling

const MyFlightBookings = () => {
    const { user } = useAuth();
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);


    useEffect(() => {
        const getBookings = async () => {
            if (!user?.id) {
                setLoading(false);
                setError("User not found. Please log in again.");
                return;
            }

            try {
                const response = await apiService.post(`${config.GETUSERFLIGHTBOOKINGS}/${user?.id}`, pageSize, pageNumber);
                setBookings(response); // Ensure bookings is always an array
            } catch (err) {
                setError("Could not fetch your flight bookings. Please try again later.");
                console.error("Failed to fetch flight bookings:", err);
            } finally {
                setLoading(false);
            }
        };

        getBookings();
    }, [user]); // Re-run if the user object changes

    const renderStatusBadge = (status) => {
        let badgeClass = 'bg-secondary';
        switch (status?.toUpperCase()) {
            case 'CONFIRMED':
            case 'SUCCESS':
                badgeClass = 'bg-success';
                break;
            case 'PENDING':
            case 'HOLD':
                badgeClass = 'bg-warning text-dark';
                break;
            case 'CANCELLED':
            case 'FAILED':
                badgeClass = 'bg-danger';
                break;
            default:
                break;
        }
        return <span className={`badge ${badgeClass}`}>{status}</span>;
    };

    return (
        <div className="main-content">
            <div className="profile-page-wrapper">
                <div className="container">
                    {/* <h2 className="profile-title text-center">My Flight Bookings</h2> */}
                    <div className="bookings-card">
                        {loading ? (
                            <div className="text-center p-2">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2">Loading your bookings...</p>
                            </div>
                        ) : error ? (
                            <div className="alert alert-danger">{error}</div>
                        ) : bookings.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Booking No / PNR</th>
                                            <th>Journey</th>
                                            <th>Booking Date</th>
                                            <th>Departure</th>
                                            <th>Travellers</th>
                                            <th>Booking Status</th>
                                            <th>Total Price</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bookings.map((booking) => (
                                            <tr key={booking.flightBookingId}>
                                                <td>
                                                    <strong>{booking.bookingNo}</strong><br />
                                                    <small className="text-muted">{booking.pnr}</small>
                                                </td>
                                                <td>{booking.flightSearchRequest?.flightTravelerPoints?.[0].from} → {booking.flightSearchRequest?.flightTravelerPoints?.[0].to}</td>
                                                <td>{moment(booking.bookingDate).format("DD MMM YYYY hh:mm a")}</td>
                                                <td>{moment(booking.departureDate).format("DD MMM YYYY")}</td>
                                                <td>
                                                    <small className="text-muted">Adults : {booking.flightSearchRequest?.adults}</small>
                                                    {booking.flightSearchRequest?.kids !== 0 ? <><br /><small className="text-muted">Kids : {booking.flightSearchRequest?.kids}</small></> : ''}
                                                    {booking.flightSearchRequest?.kids !== 0 ? <><br /><small className="text-muted">Infants : {booking.flightSearchRequest?.infants}</small></> : ''}
                                                </td>
                                                <td>{renderStatusBadge(booking.bookingStatus)}</td>
                                                <td><strong>{booking.totalPrice} {booking.currency}</strong></td>
                                                <td>
                                                    <Link to={`/my-flight/booking/${booking.flightBookingId}`} className='btn btn-sm btn-outline-primary'>
                                                        View
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center p-5">
                                <p className="mb-0">You have no flight bookings yet.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyFlightBookings;